export default __webpack_public_path__ + "static/media/airways.7f1ed10b.jpg";